import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import BulkTicketSaleForm from 'Services/SalesManagement/Features/TicketSale/Components/BulkTicketSaleForm'
import useSalesManagementBreadcrumbs from 'Services/SalesManagement/Hooks/useSalesManagementBreadcrumbs'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

export default function BulkTicketSaleCreatePage() {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/bulk-ticket-sales`
  const previousLocation = usePreviousLocation(baseUrl)
  const title = t`Sell bulk tickets`
  const breadcrumbs = useSalesManagementBreadcrumbs([
    {
      title: t`Ticket sales`
    },
    {
      title: t`Bulk ticket sales`,
      link: baseUrl
    },
    {
      title: title
    }
  ])

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{title}</PageTitle>
          <Typography component="p" variant="subtitle1" sx={{ fontSize: '15px', mb: 4 }}>
            {t`Create bulk tickets for events and companies.`}
          </Typography>
        </Grid>
      </Grid>
      <BulkTicketSaleForm onCancel={() => navigate(previousLocation)} />
    </Box>
  )
}
